/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ConvertResourceSnapshotsRequest {
  /**
  * The ID of the vault
  */
  'vaultId': string;
  /**
  * The number of days to retain the backup
  */
  'retentionDays': number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "vaultId",
      "baseName": "vaultId",
      "type": "string",
      "format": ""
    },
    {
      "name": "retentionDays",
      "baseName": "retentionDays",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ConvertResourceSnapshotsRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

